import React, {useMemo} from "react"

import PropTypes from "prop-types"
import {Button as SemanticButton, Icon as SemanticIcon} from "semantic-ui-react"

import {getDataTestId} from "../../utils/stringUtil"

import "./buttonSecondary.scss"

const ButtonSecondary = ({
    actionType,
    children,
    className = null,
    dataTestId,
    disabled = false,
    height,
    icon,
    iconPosition = "left",
    loading = false,
    width,
    ...props
}) => {
    const style = useMemo(() => {
        let style = {}
        if (width) {
            style.width = width + "rem"
        }

        if (height) {
            style.height = height + "rem"
        }

        return style
    }, [height, width])

    return (
        <SemanticButton
            aria-busy={loading}
            aria-disabled={disabled}
            aria-label={typeof children === "string" ? children : undefined}
            basic
            className={className}
            data-testid={dataTestId || getDataTestId(children, "bouton")}
            disabled={disabled || loading}
            loading={loading}
            style={style}
            tabIndex={disabled ? -1 : 0}
            type={actionType}
            {...props}
        >
            {icon && iconPosition === "left" && <SemanticIcon aria-hidden="true" className="left" name={icon} />}
            <div className="button-basic-children">{children}</div>
            {icon && iconPosition === "right" && <SemanticIcon aria-hidden="true" className="right" name={icon} />}
        </SemanticButton>
    )
}

ButtonSecondary.propTypes = {
    actionType: PropTypes.oneOf(["button", "reset", "submit"]),
    children: PropTypes.any.isRequired,
    className: PropTypes.string,
    dataTestId: PropTypes.string,
    disabled: PropTypes.bool,
    height: PropTypes.string,
    icon: PropTypes.string,
    iconPosition: PropTypes.oneOf(["left", "right"]),
    loading: PropTypes.bool,
    onClick: PropTypes.func,
    width: PropTypes.string,
}

export default ButtonSecondary
